// External packages
import { useLocation } from 'react-router';
import { Link, Outlet } from 'react-router-dom';

// Utils
import { twMerge } from 'tailwind-merge';

// Components
import { PlainButton } from 'components/Button';
import { Icon } from 'components/Icons';

// Hooks
import { useLogout } from 'api/auth';
import { useUserRole } from 'components/ProtectedRoute';

// Navigation configuration
const navigationItems = [
	{
		path: '/eksponati',
		label: 'Eksponati',
		icon: 'building',
		allowedRoles: ['ADMIN'],
	},
	{
		path: '/ulaznice',
		label: 'Ulaznice',
		icon: 'ticket',
		allowedRoles: ['ADMIN', 'USER'],
	},
	{
		path: '/sobe',
		label: 'Sobe',
		icon: 'box',
		allowedRoles: ['ADMIN'],
	},
	{
		path: '/slike',
		label: 'Slike',
		icon: 'image',
		allowedRoles: ['ADMIN'],
	},
	{
		path: '/videa',
		label: 'Videa',
		icon: 'video',
		allowedRoles: ['ADMIN'],
	},
	{
		path: '/audio',
		label: 'Audio',
		icon: 'audio',
		allowedRoles: ['ADMIN'],
	},
	{
		path: '/mape',
		label: 'Mape',
		icon: 'map',
		allowedRoles: ['ADMIN'],
	},
	{
		path: '/api-kljucevi',
		label: 'API ključevi',
		icon: 'qr',
		allowedRoles: ['ADMIN'],
	},
];

export const SideNavigation = () => {
	let location = useLocation();
	const logout = useLogout();

	const { roleValue } = useUserRole();

	return (
		<div className="flex max-md:flex-col">
			<div className="sticky top-0 left-0 z-10 flex items-center gap-12 bg-gray-100 px-6 py-4 whitespace-nowrap max-md:w-full max-md:overflow-x-auto md:top-0 md:h-full md:min-h-screen md:flex-col md:gap-8 md:px-9 md:py-12">
				<h1 className="mb-29 ml-3 shrink-0 max-md:hidden md:mr-auto">
					<strong>Muzej</strong>
				</h1>
				<div className="gap-4 max-md:flex">
					{navigationItems
						.filter(
							(item) => roleValue && item.allowedRoles.includes(roleValue)
						)
						.map((item) => (
							<Link
								key={item.path}
								to={item.path}
								className={twMerge(
									'flex items-center gap-4 rounded-lg px-3 py-1 text-gray-600 transition-colors hover:bg-gray-200 md:mb-2.5 md:py-2',
									location.pathname === item.path && 'bg-gray-200'
								)}
							>
								<Icon name={item.icon as any} className="size-5" />
								{item.label}
							</Link>
						))}
				</div>
				<PlainButton
					className="mt-auto flex w-full cursor-pointer items-center gap-4 self-start rounded-lg px-3 py-1 text-gray-600 transition-colors hover:bg-gray-200 md:mb-2.5 md:py-2"
					onPress={logout}
				>
					<Icon name="logout" className="size-5" />
					Odjava
				</PlainButton>
			</div>
			<div className="py-10 px-10 w-full md:py-16">
				<Outlet />
			</div>
		</div>
	);
};
